import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface BookmarkRequest {
  title: string;
  session_id?: string;
  message_id: string;
}

export interface BookmarkResponse {
  id: string;
  bookmark_type: string;
  title: string;
  display_title: string;
  created_at: string;
  session: {
    id: string;
    session_id: string;
    header: string;
    created_at: string;
  };
  message: {
    id: string;
    user_message: string;
    timestamp: string;
  };
}

interface BookmarkState {
  loading: boolean;
  error: string | null;
  bookmark: BookmarkResponse | null;
}

const initialState: BookmarkState = {
  loading: false,
  error: null,
  bookmark: null,
};

const createBookmarkSlice = createSlice({
  name: 'bookmark',
  initialState,
  reducers: {
    createBookmarkRequest: (state, action: PayloadAction<BookmarkRequest>) => {
      state.loading = true;
      state.error = null;
      state.bookmark = null; // reset previous
    },
    createBookmarkSuccess: (state, action: PayloadAction<BookmarkResponse>) => {
      state.loading = false;
      state.bookmark = action.payload;
    },
    createBookmarkFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  createBookmarkRequest,
  createBookmarkSuccess,
  createBookmarkFailure,
} = createBookmarkSlice.actions;

export const createBookmarkReducer = createBookmarkSlice.reducer;
